/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import type { StackDeployment } from '@modules/ui-types'

import { getVersion } from '@/lib/stackDeployments/selectors/fundamentals'
import { lt } from '@/lib/semver'

export const isDeploymentVersionBelow8dot10 = (deployment: StackDeployment): boolean => {
  const deployedVersion = getVersion({ deployment })
  return deployedVersion ? lt(deployedVersion, '8.10.0') : false
}
